import { render } from "./laikeimaccount.vue?vue&type=template&id=2a3fefd8&scoped=true"
import script from "./laikeimaccount.vue?vue&type=script&lang=js"
export * from "./laikeimaccount.vue?vue&type=script&lang=js"

import "./laikeimaccount.vue?vue&type=style&index=0&id=2a3fefd8&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3fefd8"]])

export default __exports__